import types from "./types";

const initialState = {
  validIncident: null,
  conflictingIncidents: [],
  conflictingRelationships: []
}

const incidentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_VALID_INCIDENT:
      return {
        ...state,
        validIncident: action.payload.validIncident
      }
    case types.CLEAR_VALID_INCIDENT:
      return {
        ...state,
        validIncident: null
      }
      case types.SET_CONFLICTING_INCIDENTS:
        return {
          ...state,
          conflictingIncidents: action.payload.conflictingIncidents ? action.payload.conflictingIncidents : []
        }

      case types.CLEAR_CONFLICTING_INCIDENTS:
        return {
          ...state,
          conflictingIncidents: []
        }
        case types.SET_CONFLICTING_RELATIONSHIPS:
          return {
            ...state,
            conflictingRelationships: action.payload.conflictingRelationships ? action.payload.conflictingRelationships : []
          }

        case types.CLEAR_CONFLICTING_RELATIONSHIPS:
          return {
            ...state,
            conflictingRelationships: []
          }

    default:
      return state;
  }
}

export default incidentReducer;
